export default __webpack_public_path__ + "static/media/activity03.0e72777b.JPG";